module.exports = __webpack_public_path__ + "img/how-it-works.ab71158a.png";